import { translateStatus } from "@/utils";
import { trpc } from "@/utils/trpc";

export const TestPage = () => {
	const { data } = trpc.payment.getAll.useQuery();

	return (
		<div className="flex h-screen flex-col items-center justify-center">
			<div className="flex flex-col items-center justify-center gap-4">
				<div className="p-6">
					<div className="overflow-x-auto rounded-2xl shadow-lg">
						<table className="min-w-full divide-y divide-gray-200 bg-white">
							<thead className="bg-gray-100">
								<tr>
									<th className="px-6 py-3 text-left text-sm font-semibold text-gray-600">
										Nom
									</th>
									<th className="px-6 py-3 text-left text-sm font-semibold text-gray-600">
										Email
									</th>
									<th className="px-6 py-3 text-left text-sm font-semibold text-gray-600">
										Prix
									</th>
									<th className="px-6 py-3 text-left text-sm font-semibold text-gray-600">
										Tél
									</th>
									<th className="px-6 py-3 text-left text-sm font-semibold text-gray-600">
										Hôtel
									</th>
									<th className="px-6 py-3 text-left text-sm font-semibold text-gray-600">
										Agence
									</th>

									<th className="px-6 py-3 text-left text-sm font-semibold text-gray-600">
										Statut
									</th>
									<th className="px-6 py-3 text-left text-sm font-semibold text-gray-600">
										date
									</th>
								</tr>
							</thead>
							<tbody className="divide-y divide-gray-100">
								{data?.map((payment) => (
									<tr key={payment.id} className="hover:bg-gray-50">
										<td className="px-6 py-4 text-sm text-gray-700">
											{payment.firstName} {payment.lastName}
										</td>
										<td className="px-6 py-4 text-sm text-gray-700">
											{payment.email}
										</td>
										<td className="px-6 py-4 text-sm text-gray-700">
											{payment.price}
										</td>
										<td className="px-6 py-4 text-sm text-gray-700">
											{payment.phone}
										</td>
										<td className="px-6 py-4 text-sm text-gray-700">
											{payment.hotel}
										</td>
										<td className="px-6 py-4 text-sm text-gray-700">
											{payment.agency}
										</td>

										<td className="px-6 py-4 text-sm text-gray-700">
											{translateStatus(payment.status)}
										</td>
										<td className="px-6 py-4 text-sm text-gray-700">
											{payment.createdAt.toLocaleDateString("fr-FR")}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	);
};
